import React from 'react';

import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../commonInfra/utils/ImgUrl';
import { NotificationCenterStyles } from '../styles/notificationCenterStyles';

export function NotificationLoadFail() {
  return (
    <div className='loadingNotificationFailed' style={NotificationCenterStyles.notificationEmptyList}>
      <div className='bellImg'> <img src={imgPath('notification_empty_bell.svg')} alt={Messages.userNotificationBellIconAlt()} height="80" /></div>
      <div className='errorMessage' style={NotificationCenterStyles.notificationEmptyTitle}> {Messages.userNotificationLoadError()} </div>
      <div className='tryAgainLater' style={NotificationCenterStyles.notificationSecondTitle}> {Messages.userNotificationTryAgainLater()} </div>
    </div>
  );
}
